import { Box, Flex, Button } from "rebass/styled-components";

import Hero from "../Hero";
import { Heading } from "../common";

interface Props {
  isMobileViewport: boolean;
  imgsrc: string;
  imgAlt?: string;
  title: string;
  button?: { text: string; onSubmit: () => void };
  width?: { mobile: string; nonMobile: string };
  height?: string | string[];
}

function HeroLanding(props: Props) {
  const {
    isMobileViewport,
    imgsrc,
    imgAlt,
    title,
    button,
    width = { mobile: "100%", nonMobile: "100%" },
    height = ["400px", "400px", "775px"]
  } = props;

  const variantDevice = isMobileViewport
    ? "heroLanding.mobile"
    : "heroLanding.nonMobile";
  const widthDevice = isMobileViewport ? width.mobile : width.nonMobile;

  return (
    <Hero variant="landing" imgsrc={imgsrc} imgAlt={imgAlt} height={height}>
      <Flex variant={`${variantDevice}.flex`}>
        <Heading
          as="h1"
          variant={`${variantDevice}.text`}
          sx={{ width: widthDevice }}
        >
          {title}
        </Heading>
        {button && (
          <Box variant={"heroLanding.boxButton"}>
            <Button variant={"heroLanding.button"} onClick={button.onSubmit}>
              {button.text}
            </Button>
          </Box>
        )}
      </Flex>
    </Hero>
  );
}

export default HeroLanding;
